(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ry-v1-purchase-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ryedical-purchase-reviews')) {
    customElements.define('ryedical-purchase-reviews', class RyedicalPurchaseReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-reviews-track]');
        this.nav = this.querySelector('[data-reviews-nav]');
        if (!this.track || !this.nav) return;
        this.prev = this.nav.querySelector('[data-reviews-prev]');
        this.next = this.nav.querySelector('[data-reviews-next]');
        this.prev.addEventListener('click', () => this.step(-1));
        this.next.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      step(direction) {
        const card = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({ left: distance * direction });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.nav.hidden = max <= 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    });
  }

  if (!customElements.get('ryedical-purchase-info')) {
    customElements.define('ryedical-purchase-info', class RyedicalPurchaseInfo extends HTMLElement {
      connectedCallback() {
        this.setupTabs();
        this.setupNutritionDialog();
      }

      setupTabs() {
        this.tabs = [...this.querySelectorAll('[data-tab-target]')];
        this.panels = [...this.querySelectorAll('[data-tab-panel]')];
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            const nextTab = this.tabs[(index + direction + this.tabs.length) % this.tabs.length];
            this.selectTab(nextTab);
            nextTab.focus();
          });
        });
      }

      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const selected = tab === selectedTab;
          tab.classList.toggle('is-selected', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.tabPanel !== selectedTab.dataset.tabTarget; });
      }

      setupNutritionDialog() {
        const dialog = this.querySelector('[data-nutrition-dialog]');
        if (!dialog) return;
        this.querySelector('[data-nutrition-open]')?.addEventListener('click', () => dialog.showModal());
        this.querySelector('[data-nutrition-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
